<template>
  <b-container>
    <header class="header">
      <TheTitle class="header__title">最新消息</TheTitle>
      <label class="addButton header__search">
        <NotificationButtonAdd v-if="role === 'admin' && !isMobile" />
      </label>
    </header>

    <!-- tags filter for merchant -->
    <MySwiper
      v-if="role === 'merchant'"
      style="
        margin-top: 0.25rem;
        margin-bottom: 1.25rem;
      "
      :breakpoints="{
        0: {
          slidesPerView: 'auto',
          spaceBetween: 10
        }
      }"
      hide-pagination
      :autoplay="false"
    >
      <MySwiperSlide
        :class="filter.tag === null ? 'tag__active' : 'tag'"
        @click="filter.tag = null"
      >
        所有
      </MySwiperSlide>
      <MySwiperSlide
        v-for="tag in tags"
        :key="tag"
        :class="filter.tag === tag ? 'tag__active' : 'tag'"
        @click="filter.tag = tag"
      >
        {{ tag }}
      </MySwiperSlide>
    </MySwiper>

    <TheListingTitle
      title="消息列表"
      :selectedKeywordAndFilters="selectedKeywordAndFilters"
      @reset-click="initialize"
    ></TheListingTitle>
    <!-- <section class="table-content" v-if="role === 'admin'"> -->
    <section class="table-content">
      <BaseFilterToolbar v-if="role === 'admin'" @reset="initialize" :loading="loading">
        <div class="d-flex">
          <label>
            <b-form-select class="filter keyword-select" v-model="filter.keywordType">
              <b-form-select-option
                v-for="option in filteredKeywordSelectOptions"
                :value="option.value"
                :key="option.text">
                {{ option.text }}
              </b-form-select-option>
            </b-form-select>
          </label>
          <label id="keyword-filter">
            <input
              v-model.trim="keyword"
              type="text"
              class="form-control"
              placeholder="關鍵字..."
              aria-label="關鍵字..."
              aria-describedby="button-addon1"
            />
          </label>
        </div>
        <label>
          <b-form-select class="filter" v-model="filter.status">
            <b-form-select-option
              v-for="option in filteredStatusSelectOptions"
              :value="option.value"
              :key="option.text"
            >
              {{ option.text }}
            </b-form-select-option>
          </b-form-select>
        </label>
        <label>
          <b-form-select class="filter" v-model="filter.type">
            <b-form-select-option
              v-for="option in filteredTypeSelectOptions"
              :value="option.value"
              :key="option.text"
            >
              {{ option.text }}
            </b-form-select-option>
          </b-form-select>
        </label>
        <label>
          <b-form-select class="filter" v-model="filter.displayLocation">
            <b-form-select-option
              v-for="option in filteredDisplayLocationSelectOptions"
              :value="option.value"
              :key="option.text"
            >
              {{ option.text }}
            </b-form-select-option>
          </b-form-select>
        </label>
      </BaseFilterToolbar>
      <DataTable
        v-show="list"
        :fields="fields"
        :mobileFields="mobileFields"
        :items="list"
        :total-result="total"
        :options.sync="options"
        :loading="loading"
        :mobile-searchable="isAdmin"
        showRowDetails
        @row-clicked="goToItem"
      >
        <template v-slot:cell(title)="{ value, item }">
          <div style="display: flex; align-items: center; gap: 1.25rem">
            <img
              v-if="role === 'merchant'"
              :src="item.image"
              :alt="item.id"
              :width="isMobile ? 58 : 72"
              :height="isMobile ? 34 : 42"
            />
            <div>{{ value }}</div>
          </div>
        </template>
        <template v-slot:cell(tags)="{ value: tags }">
          <div v-if="tags !== ''" style="display: flex; gap: 0.5rem">
            <b-badge
              v-for="tag in tags.toString().split(',')"
              :key="tag"
              class="tag__datatable"
              @click.stop="filter.tag = tag"
            >
              {{ tag }}
            </b-badge>
          </div>
        </template>
        <template v-slot:cell(status)="{ value }">
          <div style="width: 4rem">
            <StatusLabel :value="value"></StatusLabel>
          </div>
        </template>
        <template v-slot:cell(publishOn)="{ value }">
          <div style="width: 6rem; white-space: break-spaces">{{ value }}</div>
        </template>
        <template v-slot:cell(displayLocation)="{ value: locations }">
          <div style="display: flex; gap: 0.5rem">
            <DisplayLocationLabel
              v-for="location in locations.split(',')"
              :key="location"
              :value="location"
            ></DisplayLocationLabel>
          </div>
        </template>
        <template v-slot:cell(createdAt)="{ value }">
          <div style="width: 6rem; white-space: break-spaces">{{ value }}</div>
        </template>
        <template v-slot:cell(updatedAt)="{ value }">
          <div style="width: 6rem; white-space: break-spaces">{{ value }}</div>
        </template>

        <!-- htmlUrl desktop view -->
        <template v-slot:cell(htmlUrl)="{ value, item }">
          <div v-if="item.type === 'EDM' && value && !isMobile" style="text-align: center">
            <EdmPreviewButton :htmlUrl="value" :notificationId="item.id" />
          </div>
        </template>
        <!-- htmlUrl mobile view (in mobile details) -->
        <template v-slot:htmlUrl="{ item }">
          <div v-if="item.type === 'EDM' && item.htmlUrl && isMobile">
            <EdmPreviewButton :htmlUrl="item.htmlUrl" :notificationId="item.id" />
          </div>
          <span v-else>-</span>
        </template>
      </DataTable>
      <b-skeleton-table v-if="!list" :rows="15" :columns="5"></b-skeleton-table>
    </section>

    <!-- old merchant design -->
    <!-- <section v-else>
      <MerchantNotification :list="list"
                            :newsOnly="filter.newsOnly"
                            @newsOnly-click="updateDisplayLocation">
      </MerchantNotification>
    </section> -->
  </b-container>
</template>

<script>
import MySwiper from '@/components/my-swiper/MySwiper.vue';
import MySwiperSlide from '@/components/my-swiper/MySwiperSlide.vue';
// import MerchantNotification from '@/components/notification/MerchantNotification.vue';
import NotificationButtonAdd from '@/components/notification/NotificationButtonAdd.vue';
import axios from 'axios';
import {
  BBadge,
  BContainer,
  BSkeletonTable,
  BFormSelect,
  BFormSelectOption,
} from 'bootstrap-vue';
import { asyncScheduler, scheduled } from 'rxjs';
import {
  debounceTime, map, mergeAll, pluck, switchMap, tap,
} from 'rxjs/operators';
import { mapGetters } from 'vuex';
import DataTable from '../../components/DataTable.vue';
import TheTitle from '../../components/TheTitle.vue';
import DisplayLocationLabel from '../../components/notification/DisplayLocationLabel.vue';
import EdmPreviewButton from '../../components/notification/EdmPreviewButton.vue';
import StatusLabel from '../../components/notification/StatusLabel.vue';
import dataTableMixin from '../../mixins/data-table';
import isMobileMixin from '../../mixins/is-mobile';
import BaseFilterToolbar from '../../components/BaseFilterToolbar.vue';
import TheListingTitle from '../../components/TheListingTitle.vue';
import filtersQueryStringMixin from '../../mixins/filtersQueryString';
import optionsQueryStringMixin from '../../mixins/optionsQueryString';

export default {
  mixins: [dataTableMixin, isMobileMixin, filtersQueryStringMixin, optionsQueryStringMixin],
  components: {
    MySwiper,
    MySwiperSlide,
    DataTable,
    TheTitle,
    NotificationButtonAdd,
    BBadge,
    BContainer,
    BSkeletonTable,
    DisplayLocationLabel,
    EdmPreviewButton,
    StatusLabel,
    // MerchantNotification,
    BaseFilterToolbar,
    BFormSelect,
    BFormSelectOption,
    TheListingTitle,
  },
  data: () => ({
    tags: [],
    filter: {
      tag: null,
      keywordType: 'all',
      status: undefined,
      type: undefined,
      displayLocation: undefined,
    },
    options: {
      page: 1,
      size: 15,
      order: 'desc',
    },
    keyword: '',
    keywordSelectOptions: [
      { value: 'all', text: '所有關鍵字' },
      { value: 'id', text: '參考編號' },
      { value: 'title', text: '標題' },
    ],
    statusSelectOptions: [
      { value: undefined, text: '所有狀態' },
      { value: 'PENDING', text: '待發佈' },
      { value: 'PUBLISHED', text: '已發佈' },
      { value: 'DRAFT', text: '草稿' },
    ],
    typeSelectOptions: [
      { value: undefined, text: '所有類型' },
      { value: 'BLOG', text: 'BLOG' },
      { value: 'EDM', text: 'EDM' },
    ],
    displayLocationSelectOptions: [
      { value: undefined, text: '所有頁面' },
      { value: 'MARKETING', text: '行銷趨勢' },
      { value: 'NEWS', text: '最新消息' },
    ],
    selected: [],
  }),
  computed: {
    ...mapGetters(['role']),
    fields() {
      return this.role === 'admin'
        ? [
          { key: 'id', label: '參考編號', sortable: true },
          { key: 'title', label: '標題', sortable: true },
          { key: 'status', label: '狀態', sortable: true },
          { key: 'type', label: '類型', sortable: true },
          { key: 'publishOn', label: '發佈時間', sortable: true },
          { key: 'displayLocation', label: '發佈頁面', sortable: false },
          { key: 'createdAt', label: '創建時間', sortable: true },
          { key: 'updatedAt', label: '最後更新時間', sortable: true },
          { key: 'htmlUrl', label: 'EDM 預覽', sortable: false },
        ]
        : [
          { key: 'title', label: '消息標題', sortable: true },
          { key: 'tags', label: 'Tags', sortable: false },
          { key: 'publishOn', label: '發佈時間', sortable: true },
        ];
    },
    mobileFields() {
      return this.role === 'admin'
        ? [
          { key: 'title', label: '標題', sortable: true },
          { key: 'status', label: '狀態', sortable: true },
        ]
        : [{ key: 'title', label: '消息標題', sortable: true }];
    },
    isAdmin() {
      return this.role === 'admin';
    },
  },
  subscriptions() {
    const getData$ = (data) => this.httpRequest$(
      {
        method: 'GET',
        url: `/agc-${this.role}-api/notification`,
      },
      {
        ...data,
        tagName: this.filter.tag,
      },
    );

    return {
      list: scheduled([...this.scheduleTasks], asyncScheduler).pipe(
        mergeAll(),
        tap(() => { this.loading = true; }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
          },
          options: this.options,
        })),
        pluck('data'),
        switchMap(getData$),
      ),
    };
  },
  methods: {
    goToItem({ id }) {
      this.$router.push({
        path: `${this.$route.path}/${id}`,
      });
    },
    initialize() {
      this.filter.keywordType = 'all';
      this.keyword = '';
      this.filter.status = undefined;
      this.filter.type = undefined;
      this.filter.displayLocation = undefined;
      setTimeout(() => {
        this.loading = false;
      }, 550);
    // when user updates filter too fast, the loading state will not set back to false
    // this time must be bigger than debounceTime's time
    },
  },
  mounted() {
    axios
      .get(`/agc-${this.role}-api/notification/tag`)
      .then(({ data: { payload } }) => payload)
      .then((res) => {
        if (res) {
          this.tags = res.map(({ name }) => name);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally();
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/data-table/list-table-content";
@import "../../assets/scss/listing/header";

.tag {
  width: fit-content;
  padding: 0.25rem 1rem;
  line-height: 25px;
  font-size: 18px;
  color: #351c75;
  background: #d8d8d8;
  text-align: center;
  border-radius: 6px;
  cursor: pointer;

  &__datatable {
    @extend .tag;

    padding: 0.25rem 0.75rem;
    line-height: 100%;
    font-size: 1rem;
    font-weight: normal;
  }

  &__active {
    @extend .tag;

    color: #ffffff;
    background: #351c75;
  }
}

.addButton {
  padding-top: 25px;
}

h4 {
  color: #174169;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 25px;
  margin-bottom: 1rem;
}

::v-deep {
  table {
    td:nth-of-type(2) {
      max-width: 25rem;
    }

    th:first-of-type,
    td:first-of-type {
      padding-left: 1.5rem !important;

      @include respond(tab-landscape) {
        padding-left: 1rem !important;
      }
    }

    .b-table-details .row .col-4 {
      padding-right: 0;
      font-size: 0.75rem;
    }
  }
  .data-table[data-v-1bcc6778] .right-corner {
    right: 20%;
  }
}
</style>
